import { IValidation } from '../validation.interfaces';
import { DateExpressionParser } from '../../configuration/date-expressions';
import { DateHelper } from '../../utilities/date-helper';

export class DateValidation implements IValidation {
    validate(parameters: any, value: any): boolean | Promise<boolean> {
        value = DateHelper.castDate(value);
        const minDateExp: string = parameters.minDateExpression;
        const maxDateExp: string = parameters.maxDateExpression;

        const minDate = DateExpressionParser.isDateExpression(minDateExp) ? DateExpressionParser.getDateValue(minDateExp, null) : new Date(minDateExp);
        const maxDate = DateExpressionParser.isDateExpression(maxDateExp) ? DateExpressionParser.getDateValue(maxDateExp, null) : new Date(maxDateExp);
        return (!minDateExp || value >= minDate) && (!maxDateExp || value <= maxDate);
    }

    canValidate(): boolean | Promise<boolean> {
        return true;
    }
}
